// src/pages/SMSInbox.js
import React, { useState, useEffect } from "react";
import {
    getConversations,
    getConversationMessages,
    sendSMS,
} from "../services/smsService";
import { getLeads } from "../services/leadsService";
import "./SMSInbox.css";

// Dummy data for conversations
const dummyConversations = [
    {
        id: 1,
        contact: "John Anderson",
        phone: "(405) 555-1234",
        avatar: "",
        lastMessage: "I'll definitely call Senator Treat about this issue.",
        lastMessageAt: new Date(Date.now() - 15 * 60000).toISOString(), // 15 minutes ago
        unread: false,
        district: "District 3"
    },
    {
        id: 2,
        contact: "Sarah Johnson",
        phone: "(405) 555-7890",
        avatar: "",
        lastMessage: "Thanks for the information about the Senate bill.",
        lastMessageAt: new Date(Date.now() - 2 * 60 * 60000).toISOString(), // 2 hours ago
        unread: true,
        district: "District 1"
    },
    {
        id: 3,
        contact: "Michael Wilson",
        phone: "(405) 555-4321",
        avatar: "",
        lastMessage: "YES, I'd like to stay informed about similar issues.",
        lastMessageAt: new Date(Date.now() - 1 * 24 * 60 * 60000).toISOString(), // 1 day ago
        unread: false,
        district: "District 5"
    },
    {
        id: 4,
        contact: "Emma Davis",
        phone: "(405) 555-5678",
        avatar: "",
        lastMessage: "I called the senator's office today.",
        lastMessageAt: new Date(Date.now() - 2 * 24 * 60 * 60000).toISOString(), // 2 days ago
        unread: true,
        district: "District 2"
    },
    {
        id: 5,
        contact: "Robert Martinez",
        phone: "(405) 555-2468",
        avatar: "",
        lastMessage: "YES - please keep me updated on healthcare issues.",
        lastMessageAt: new Date(Date.now() - 3 * 24 * 60 * 60000).toISOString(), // 3 days ago
        unread: false,
        district: "District 4"
    },
    {
        id: 6,
        contact: "Jennifer Taylor",
        phone: "(405) 555-3691",
        avatar: "",
        lastMessage: "When is the deadline for the Senate to reconsider?",
        lastMessageAt: new Date(Date.now() - 5 * 24 * 60 * 60000).toISOString(), // 5 days ago
        unread: false,
        district: "District 3"
    },
    {
        id: 7,
        contact: "David Brown",
        phone: "(405) 555-8765",
        avatar: "",
        lastMessage: "I'm concerned about healthcare access in Oklahoma.",
        lastMessageAt: new Date(Date.now() - 6 * 24 * 60 * 60000).toISOString(),
        unread: true,
        district: "District 1"
    },
    {
        id: 8,
        contact: "Maria Garcia",
        phone: "(405) 555-9876",
        avatar: "",
        lastMessage: "YES",
        lastMessageAt: new Date(Date.now() - 7 * 24 * 60 * 60000).toISOString(),
        unread: false,
        district: "District 2"
    },
    {
        id: 9,
        contact: "James Wilson",
        phone: "(405) 555-3456",
        avatar: "",
        lastMessage: "I want to volunteer to help with this cause.",
        lastMessageAt: new Date(Date.now() - 8 * 24 * 60 * 60000).toISOString(),
        unread: false,
        district: "District 4"
    },
    {
        id: 10,
        contact: "Patricia Moore",
        phone: "(405) 555-6789",
        avatar: "",
        lastMessage: "What other bills should I be aware of?",
        lastMessageAt: new Date(Date.now() - 9 * 24 * 60 * 60000).toISOString(),
        unread: true,
        district: "District 5"
    },
    {
        id: 11,
        contact: "Richard Clark",
        phone: "(405) 555-4567",
        avatar: "",
        lastMessage: "YES - I want updates on healthcare legislation.",
        lastMessageAt: new Date(Date.now() - 10 * 24 * 60 * 60000).toISOString(),
        unread: false,
        district: "District 3"
    },
    {
        id: 12,
        contact: "Elizabeth White",
        phone: "(405) 555-7654",
        avatar: "",
        lastMessage: "I'll share this information with my colleagues.",
        lastMessageAt: new Date(Date.now() - 11 * 24 * 60 * 60000).toISOString(),
        unread: false,
        district: "District 1"
    },
    {
        id: 13,
        contact: "Thomas Lewis",
        phone: "(405) 555-8901",
        avatar: "",
        lastMessage: "Can you provide more details about the bill?",
        lastMessageAt: new Date(Date.now() - 12 * 24 * 60 * 60000).toISOString(),
        unread: true,
        district: "District 2"
    },
    {
        id: 14,
        contact: "Nancy Young",
        phone: "(405) 555-2345",
        avatar: "",
        lastMessage: "YES, count me in for updates.",
        lastMessageAt: new Date(Date.now() - 13 * 24 * 60 * 60000).toISOString(),
        unread: false,
        district: "District 4"
    },
    {
        id: 15,
        contact: "William Harris",
        phone: "(405) 555-5432",
        avatar: "",
        lastMessage: "I support healthcare professionals' rights.",
        lastMessageAt: new Date(Date.now() - 14 * 24 * 60 * 60000).toISOString(),
        unread: false,
        district: "District 5"
    },
    {
        id: 16,
        contact: "Susan Allen",
        phone: "(405) 555-8765",
        avatar: "",
        lastMessage: "I made the call. The aide was very receptive.",
        lastMessageAt: new Date(Date.now() - 15 * 24 * 60 * 60000).toISOString(),
        unread: true,
        district: "District 1"
    },
    {
        id: 17,
        contact: "Charles King",
        phone: "(405) 555-9012",
        avatar: "",
        lastMessage: "YES - please add me to your list.",
        lastMessageAt: new Date(Date.now() - 16 * 24 * 60 * 60000).toISOString(),
        unread: false,
        district: "District 3"
    },
    {
        id: 18,
        contact: "Karen Scott",
        phone: "(405) 555-3210",
        avatar: "",
        lastMessage: "I'm a nurse and this bill is important to me.",
        lastMessageAt: new Date(Date.now() - 17 * 24 * 60 * 60000).toISOString(),
        unread: false,
        district: "District 2"
    },
    {
        id: 19,
        contact: "Daniel Green",
        phone: "(405) 555-6543",
        avatar: "",
        lastMessage: "Thank you for bringing this to my attention.",
        lastMessageAt: new Date(Date.now() - 18 * 24 * 60 * 60000).toISOString(),
        unread: true,
        district: "District 4"
    },
    {
        id: 20,
        contact: "Margaret Baker",
        phone: "(405) 555-8901",
        avatar: "",
        lastMessage: "YES, adding my voice to this issue.",
        lastMessageAt: new Date(Date.now() - 19 * 24 * 60 * 60000).toISOString(),
        unread: false,
        district: "District 5"
    }
];

// Dummy conversation messages for each contact
const dummyMessages = {
    "John Anderson": [
        {
            id: 101,
            body: "Thank you John for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 120 * 60000).toISOString(), // 2 hours ago
        },
        {
            id: 102,
            body: "Thanks for reaching out. What exactly is HB-3214 about?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 110 * 60000).toISOString(), // 1hr 50min ago
        },
        {
            id: 103,
            body: "HB-3214 protects healthcare professionals from being forced to perform procedures that violate their moral or ethical beliefs. It's about freedom of conscience for doctors and nurses.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 100 * 60000).toISOString(), // 1hr 40min ago
        },
        {
            id: 104,
            body: "I see, that does sound important. Has the bill been passed yet?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 90 * 60000).toISOString(), // 1hr 30min ago
        },
        {
            id: 105,
            body: "The Oklahoma House passed it, but it failed in a Senate Committee vote last week. We're asking people to call Senator Treat to reconsider the bill this week.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 80 * 60000).toISOString(), // 1hr 20min ago
        },
        {
            id: 106,
            body: "I understand. I care about healthcare in our state. What's the best way to reach Senator Treat?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 60 * 60000).toISOString(), // 1hr ago
        },
        {
            id: 107,
            body: "You can call Senator Treat's office directly at 405-521-5632. Just give them your name and address and tell them you support passing HB-3214.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 45 * 60000).toISOString(), // 45min ago
        },
        {
            id: 108,
            body: "Got it. I'll call them today.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 30 * 60000).toISOString(), // 30min ago
        },
        {
            id: 109,
            body: "Thank you so much! Your voice makes a real difference. Would you like to stay informed about similar issues?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 25 * 60000).toISOString(), // 25min ago
        },
        {
            id: 110,
            body: "I'll definitely call Senator Treat about this issue.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 15 * 60000).toISOString(), // 15min ago
        }
    ],
    "Sarah Johnson": [
        {
            id: 201,
            body: "Hello Sarah, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 5 * 60 * 60000).toISOString(), // 5 hours ago
        },
        {
            id: 202,
            body: "Thanks for the information. I've been following healthcare legislation closely.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 4.5 * 60 * 60000).toISOString(), // 4.5 hours ago
        },
        {
            id: 203,
            body: "That's great to hear! HB-3214 is particularly important because it affects both healthcare providers and patients. Have you had a chance to review the specifics?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 4 * 60 * 60000).toISOString(), // 4 hours ago
        },
        {
            id: 204,
            body: "Not in detail yet. What are the key provisions?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 3.5 * 60 * 60000).toISOString(), // 3.5 hours ago
        },
        {
            id: 205,
            body: "The bill ensures healthcare professionals can't be forced to perform procedures that violate their ethical beliefs. It also protects them from discrimination or retaliation for exercising these rights.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 3 * 60 * 60000).toISOString(), // 3 hours ago
        },
        {
            id: 206,
            body: "I see why this is important. So what's happening with it in the legislature?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 2.5 * 60 * 60000).toISOString(), // 2.5 hours ago
        },
        {
            id: 207,
            body: "It passed the House but then failed in a Senate Committee vote. We need Senator Treat to bring it up for reconsideration this week, which is why your call is so important.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 2.2 * 60 * 60000).toISOString(), // 2.2 hours ago
        },
        {
            id: 208,
            body: "Thanks for the information about the Senate bill.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 2 * 60 * 60000).toISOString(), // 2 hours ago
        }
    ],
    "Michael Wilson": [
        {
            id: 301,
            body: "Thank you Michael for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 36 * 60 * 60000).toISOString(), // 36 hours ago
        },
        {
            id: 302,
            body: "You're welcome. I'm glad I could help. What exactly will this bill do?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 30 * 60 * 60000).toISOString(), // 30 hours ago
        },
        {
            id: 303,
            body: "HB-3214 ensures that healthcare professionals have the right to decline participating in procedures that conflict with their moral or religious beliefs, without facing discrimination or job loss.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 28 * 60 * 60000).toISOString(), // 28 hours ago
        },
        {
            id: 304,
            body: "That makes sense. I definitely support that. Will it affect patients' access to care?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 26 * 60 * 60000).toISOString(), // 26 hours ago
        },
        {
            id: 305,
            body: "The bill actually helps maintain access by keeping healthcare professionals in the state who might otherwise leave due to conscience concerns. There are provisions to ensure patients can still access care from willing providers.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 24 * 60 * 60000).toISOString(), // 24 hours ago
        },
        {
            id: 306,
            body: "YES, I'd like to stay informed about similar issues.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 22 * 60 * 60000).toISOString(), // 22 hours ago
        }
    ],
    "Emma Davis": [
        {
            id: 401,
            body: "Hello Emma, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 3 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 402,
            body: "Hi there. I'm interested in learning more about this bill.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 3 * 24 * 60 * 60000 + 30 * 60000).toISOString(),
        },
        {
            id: 403,
            body: "HB-3214 protects healthcare professionals from being forced to participate in procedures that violate their ethical or religious beliefs. It passed the House but was stopped in a Senate committee.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 3 * 24 * 60 * 60000 + 45 * 60000).toISOString(),
        },
        {
            id: 404,
            body: "That's important. I believe healthcare workers should have those protections.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 3 * 24 * 60 * 60000 + 60 * 60000).toISOString(),
        },
        {
            id: 405,
            body: "We agree! Senator Treat has the power to bring this up for reconsideration. A call from you could make a real difference.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 3 * 24 * 60 * 60000 + 75 * 60000).toISOString(),
        },
        {
            id: 406,
            body: "I understand. I'll call today.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 2 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 407,
            body: "Thank you Emma! Your voice matters in this important issue. Would you like to stay updated on this and similar legislation?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 2 * 24 * 60 * 60000 + 30 * 60000).toISOString(),
        },
        {
            id: 408,
            body: "I called the senator's office today.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 2 * 24 * 60 * 60000 + 5 * 60 * 60000).toISOString(),
        }
    ],
    "Robert Martinez": [
        {
            id: 501,
            body: "Thank you Robert for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 4 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 502,
            body: "Happy to support this important legislation. It aligns with my values.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 4 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 503,
            body: "We appreciate your support, Robert! It's advocates like you who can help get this bill reconsidered. Were you able to speak with anyone at Senator Treat's office?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 4 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 504,
            body: "Yes, I spoke with an aide who said they'd pass along my concerns.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 4 * 24 * 60 * 60000 + 4 * 60 * 60000).toISOString(),
        },
        {
            id: 505,
            body: "That's excellent! Every call is logged and makes a difference. Would you like to receive updates about this bill and similar healthcare legislation?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 3.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 506,
            body: "YES - please keep me updated on healthcare issues.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 3 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Jennifer Taylor": [
        {
            id: 601,
            body: "Hello Jennifer, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 6 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 602,
            body: "I'm interested in this issue. How much time do we have to influence the decision?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 6 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 603,
            body: "The Senate needs to reconsider this bill soon. We're hoping Senator Treat will bring it up for reconsideration this week, which is why calls now are so important.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 6 * 24 * 60 * 60000 + 4 * 60 * 60000).toISOString(),
        },
        {
            id: 604,
            body: "I see. I'll try to call tomorrow. What exactly should I say?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 5.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 605,
            body: "Just introduce yourself as an Oklahoma resident, briefly express your support for HB-3214, and ask that the bill be reconsidered. Mention that you care about protecting healthcare professionals' conscience rights.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 5.5 * 24 * 60 * 60000 + 1 * 60 * 60000).toISOString(),
        },
        {
            id: 606,
            body: "When is the deadline for the Senate to reconsider?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 5 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "David Brown": [
        {
            id: 701,
            body: "Thank you David for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 7 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 702,
            body: "Thanks for the follow-up. I'm worried about the state of healthcare in Oklahoma.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 7 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 703,
            body: "Your concern is valid. Without these protections, many healthcare professionals may leave our state, which would worsen our already challenging healthcare access issues.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 7 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 704,
            body: "I'm concerned about healthcare access in Oklahoma.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 6 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Maria Garcia": [
        {
            id: 801,
            body: "Hello Maria, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 8 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 802,
            body: "I'll call the senator's office. This sounds important.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 8 * 24 * 60 * 60000 + 5 * 60 * 60000).toISOString(),
        },
        {
            id: 803,
            body: "Thank you Maria! Your support means a lot. Would you like to receive updates about this and other important healthcare legislation?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 7.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 804,
            body: "YES",
            direction: "inbound",
            createdAt: new Date(Date.now() - 7 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "James Wilson": [
        {
            id: 901,
            body: "Thank you James for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 9 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 902,
            body: "Happy to help. This is an issue I care deeply about.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 9 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 903,
            body: "We appreciate your passion, James! It's citizens like you who make a real difference in protecting these important rights.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 9 * 24 * 60 * 60000 + 4 * 60 * 60000).toISOString(),
        },
        {
            id: 904,
            body: "Is there any other way I can help besides calling?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 8.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 905,
            body: "Yes! You can help by spreading the word to friends and family, sharing information on social media, or even volunteering with our organization if you're interested.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 8.5 * 24 * 60 * 60000 + 1 * 60 * 60000).toISOString(),
        },
        {
            id: 906,
            body: "I want to volunteer to help with this cause.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 8 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Patricia Moore": [
        {
            id: 1001,
            body: "Hello Patricia, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 10 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1002,
            body: "I've been following healthcare legislation for a while. Are there other bills I should know about?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 10 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 1003,
            body: "Yes, there are several other healthcare bills being considered this session. If you'd like, we can keep you updated on those as well. But right now, HB-3214 is our highest priority because of the upcoming deadline.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 10 * 24 * 60 * 60000 + 5 * 60 * 60000).toISOString(),
        },
        {
            id: 1004,
            body: "I understand. I'll call about HB-3214 first.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 9.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1005,
            body: "Thank you! Your call really does make a difference. Would you like to receive updates about other healthcare legislation as well?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 9.5 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 1006,
            body: "What other bills should I be aware of?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 9 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Richard Clark": [
        {
            id: 1101,
            body: "Thank you Richard for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 11 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1102,
            body: "I believe strongly in this issue. Please keep me updated.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 11 * 24 * 60 * 60000 + 4 * 60 * 60000).toISOString(),
        },
        {
            id: 1103,
            body: "We're glad to hear that, Richard! We'll add you to our updates list. Your continued support helps us protect these essential rights for healthcare professionals.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 10.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1104,
            body: "YES - I want updates on healthcare legislation.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 10 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Elizabeth White": [
        {
            id: 1201,
            body: "Hello Elizabeth, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 12 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1202,
            body: "I work in the healthcare field and this is very relevant to me and my colleagues.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 12 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 1203,
            body: "Your perspective is especially valuable then! Healthcare professionals like you are exactly who this bill aims to protect. Would you be willing to share this information with your colleagues?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 12 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 1204,
            body: "Absolutely. We've been discussing this issue at work already.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 11.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1205,
            body: "That's wonderful! Collective action from healthcare professionals can have a powerful impact. Thank you for being an advocate within your workplace.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 11.5 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 1206,
            body: "I'll share this information with my colleagues.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 11 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Thomas Lewis": [
        {
            id: 1301,
            body: "Thank you Thomas for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 13 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1302,
            body: "I'm not fully familiar with the details. Can you explain the bill further?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 13 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 1303,
            body: "Of course! HB-3214 would protect healthcare professionals from being forced to participate in procedures that violate their moral or ethical beliefs. It also prohibits discrimination against them for exercising these rights.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 13 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 1304,
            body: "What procedures specifically does this cover?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 12.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1305,
            body: "The bill covers a range of elective medical procedures where ethical or moral objections might arise. The key is that it applies to elective procedures, not emergency care where someone's life is at risk.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 12.5 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 1306,
            body: "Can you provide more details about the bill?",
            direction: "inbound",
            createdAt: new Date(Date.now() - 12 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Nancy Young": [
        {
            id: 1401,
            body: "Hello Nancy, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 14 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1402,
            body: "I appreciate you reaching out about this. I'll make that call.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 14 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 1403,
            body: "Thank you, Nancy! Your voice can make a real difference. Would you like to receive updates about this bill's progress and other similar issues?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 14 * 24 * 60 * 60000 + 5 * 60 * 60000).toISOString(),
        },
        {
            id: 1404,
            body: "YES, count me in for updates.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 13 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "William Harris": [
        {
            id: 1501,
            body: "Thank you William for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 15 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1502,
            body: "I believe this is an important issue for our healthcare system.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 15 * 24 * 60 * 60000 + 4 * 60 * 60000).toISOString(),
        },
        {
            id: 1503,
            body: "We couldn't agree more, William. Without these protections, we risk losing talented healthcare providers who may leave Oklahoma for states with better conscience protections.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 15 * 24 * 60 * 60000 + 6 * 60 * 60000).toISOString(),
        },
        {
            id: 1504,
            body: "I support healthcare professionals' rights.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 14 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Susan Allen": [
        {
            id: 1601,
            body: "Hello Susan, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 16 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1602,
            body: "I just called Senator Treat's office. The staffer was very polite.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 16 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 1603,
            body: "Thank you so much for making that call, Susan! Every call is logged and helps show the level of public support. Did the staffer give you any indication of the Senator's position?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 16 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 1604,
            body: "They just said they'd pass along my concerns. They seemed receptive though.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 15.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1605,
            body: "That's good to hear! Would you like to stay updated on the progress of this bill and other similar issues?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 15.5 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 1606,
            body: "I made the call. The aide was very receptive.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 15 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Charles King": [
        {
            id: 1701,
            body: "Thank you Charles for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 17 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1702,
            body: "I'm glad to help. Please keep me updated on this and similar issues.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 17 * 24 * 60 * 60000 + 4 * 60 * 60000).toISOString(),
        },
        {
            id: 1703,
            body: "We'd be happy to keep you informed, Charles. Your interest and support are greatly appreciated!",
            direction: "outbound",
            createdAt: new Date(Date.now() - 17 * 24 * 60 * 60000 + 5 * 60 * 60000).toISOString(),
        },
        {
            id: 1704,
            body: "YES - please add me to your list.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 16 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Karen Scott": [
        {
            id: 1801,
            body: "Hello Karen, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 18 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1802,
            body: "As a nurse, this bill is very important to me. We need these protections.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 18 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 1803,
            body: "Your perspective as a healthcare professional is incredibly valuable, Karen. Have you experienced situations where these protections would have helped?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 18 * 24 * 60 * 60000 + 4 * 60 * 60000).toISOString(),
        },
        {
            id: 1804,
            body: "Yes, several times. My colleagues and I often discuss how important these protections are for our profession.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 17.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1805,
            body: "Thank you for sharing that. Would you be willing to call Senator Treat's office and share your professional experience? That kind of testimony can be very powerful.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 17.5 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 1806,
            body: "I'm a nurse and this bill is important to me.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 17 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Daniel Green": [
        {
            id: 1901,
            body: "Thank you Daniel for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 19 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 1902,
            body: "Happy to help. I wasn't aware of this issue before your call.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 19 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 1903,
            body: "We're glad we could bring it to your attention! Many Oklahomans care deeply about these issues once they learn about them. Would you like to stay informed about similar issues in the future?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 19 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 1904,
            body: "Thank you for bringing this to my attention.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 18 * 24 * 60 * 60000).toISOString(),
        }
    ],
    "Margaret Baker": [
        {
            id: 2001,
            body: "Hello Margaret, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 20 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 2002,
            body: "I support this initiative. Our healthcare workers deserve these protections.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 20 * 24 * 60 * 60000 + 3 * 60 * 60000).toISOString(),
        },
        {
            id: 2003,
            body: "We couldn't agree more, Margaret! Would you be willing to call Senator Treat's office to express your support? Every call increases the chance of this bill being reconsidered.",
            direction: "outbound",
            createdAt: new Date(Date.now() - 20 * 24 * 60 * 60000 + 4 * 60 * 60000).toISOString(),
        },
        {
            id: 2004,
            body: "Yes, I'll call today. And please keep me updated on this issue.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 19.5 * 24 * 60 * 60000).toISOString(),
        },
        {
            id: 2005,
            body: "Thank you Margaret! We'll definitely keep you updated. Would you like to reply YES to confirm you want to receive updates on similar issues?",
            direction: "outbound",
            createdAt: new Date(Date.now() - 19.5 * 24 * 60 * 60000 + 2 * 60 * 60000).toISOString(),
        },
        {
            id: 2006,
            body: "YES, adding my voice to this issue.",
            direction: "inbound",
            createdAt: new Date(Date.now() - 19 * 24 * 60 * 60000).toISOString(),
        }
    ]
};

// Dummy leads for the compose modal
const dummyLeads = [
    {
        id: 1001,
        firstName: "Patricia",
        lastName: "Garcia",
        phone: "(405) 555-9876",
        district: "District 1",
        supportLevel: "Likely Support"
    },
    {
        id: 1002,
        firstName: "David",
        lastName: "Clark",
        phone: "(405) 555-5432",
        district: "District 2",
        supportLevel: "Strong Support"
    },
    {
        id: 1003,
        firstName: "Michelle",
        lastName: "Thompson",
        phone: "(405) 555-8765",
        district: "District 3",
        supportLevel: "Undecided"
    },
    {
        id: 1004,
        firstName: "Thomas",
        lastName: "White",
        phone: "(405) 555-2345",
        district: "District 4",
        supportLevel: "Leaning Support"
    },
    {
        id: 1005,
        firstName: "Jessica",
        lastName: "Brown",
        phone: "(405) 555-7654",
        district: "District 5",
        supportLevel: "Needs Information"
    },
    {
        id: 1006,
        firstName: "Kevin",
        lastName: "Miller",
        phone: "(405) 555-3456",
        district: "District 1",
        supportLevel: "Strong Support"
    },
    {
        id: 1007,
        firstName: "Amanda",
        lastName: "Harris",
        phone: "(405) 555-6543",
        district: "District 2",
        supportLevel: "Undecided"
    },
    {
        id: 1008,
        firstName: "Christopher",
        lastName: "Johnson",
        phone: "(405) 555-7890",
        district: "District 3",
        supportLevel: "Likely Support"
    },
    {
        id: 1009,
        firstName: "Stephanie",
        lastName: "Wilson",
        phone: "(405) 555-4321",
        district: "District 4",
        supportLevel: "Strong Support"
    },
    {
        id: 1010,
        firstName: "Matthew",
        lastName: "Jones",
        phone: "(405) 555-8765",
        district: "District 5",
        supportLevel: "Needs Information"
    },
    {
        id: 1011,
        firstName: "Rebecca",
        lastName: "Martinez",
        phone: "(405) 555-2468",
        district: "District 1",
        supportLevel: "Leaning Support"
    },
    {
        id: 1012,
        firstName: "Andrew",
        lastName: "Taylor",
        phone: "(405) 555-3691",
        district: "District 2",
        supportLevel: "Undecided"
    },
    {
        id: 1013,
        firstName: "Lauren",
        lastName: "Davis",
        phone: "(405) 555-5678",
        district: "District 3",
        supportLevel: "Strong Support"
    },
    {
        id: 1014,
        firstName: "Joshua",
        lastName: "Anderson",
        phone: "(405) 555-1234",
        district: "District 4",
        supportLevel: "Likely Support"
    },
    {
        id: 1015,
        firstName: "Nicole",
        lastName: "Thomas",
        phone: "(405) 555-9012",
        district: "District 5",
        supportLevel: "Leaning Support"
    }
];

const SMSInbox = () => {
    const [conversations, setConversations] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [selectedContactData, setSelectedContactData] = useState(null);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const [loadingConversations, setLoadingConversations] = useState(false);
    const [loadingMessages, setLoadingMessages] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    // State for the Compose New Message modal.
    const [isComposeModalOpen, setIsComposeModalOpen] = useState(false);
    const [composeLeads, setComposeLeads] = useState([]);
    const [loadingComposeLeads, setLoadingComposeLeads] = useState(false);

    // For demo purposes, directly use the dummy data
    useEffect(() => {
        // Simulate loading
        setLoadingConversations(true);
        setTimeout(() => {
            setConversations(dummyConversations);
            setLoadingConversations(false);
        }, 800);
    }, []);

    // Select conversation and load messages
    const handleSelectConversation = (contactName) => {
        setSelectedContact(contactName);
        const contactData = conversations.find(c => c.contact === contactName);
        setSelectedContactData(contactData);
        
        // Simulate loading messages
        setLoadingMessages(true);
        setTimeout(() => {
            setMessages(dummyMessages[contactName] || []);
            setLoadingMessages(false);
            
            // Mark as read if it was unread
            if (contactData?.unread) {
                setConversations(prev => 
                    prev.map(c => c.contact === contactName ? {...c, unread: false} : c)
                );
            }
        }, 600);
    };

    const handleSendMessage = () => {
        if (!selectedContact || newMessage.trim() === "") return;
        
        // Create a new message and add it to the current conversation
        const newMsg = {
            id: Date.now(), // Use timestamp as ID
            body: newMessage,
            direction: "outbound",
            createdAt: new Date().toISOString()
        };
        
        setMessages(prev => [...prev, newMsg]);
        
        // Update the conversation's last message
        setConversations(prev => 
            prev.map(c => c.contact === selectedContact 
                ? {...c, lastMessage: newMessage, lastMessageAt: new Date().toISOString()}
                : c
            )
        );
        
        setNewMessage("");
    };

    // Open compose modal and load leads
    const openComposeModal = () => {
        setIsComposeModalOpen(true);
        setLoadingComposeLeads(true);
        
        // Simulate API call
        setTimeout(() => {
            setComposeLeads(dummyLeads);
            setLoadingComposeLeads(false);
        }, 800);
    };

    const closeComposeModal = () => {
        setIsComposeModalOpen(false);
    };

    // Handle selecting a lead from the compose modal
    const handleSelectLeadForCompose = (lead) => {
        // Check if this lead already has a conversation
        const existingConversation = conversations.find(c => 
            c.phone === lead.phone || c.contact === `${lead.firstName} ${lead.lastName}`
        );
        
        if (existingConversation) {
            setSelectedContact(existingConversation.contact);
            handleSelectConversation(existingConversation.contact);
        } else {
            // Create a new conversation for this lead
            const newConversation = {
                id: Date.now(),
                contact: `${lead.firstName} ${lead.lastName}`,
                phone: lead.phone,
                avatar: "",
                lastMessage: "",
                lastMessageAt: new Date().toISOString(),
                unread: false,
                district: lead.district
            };
            
            setConversations(prev => [newConversation, ...prev]);
            setSelectedContact(newConversation.contact);
            setSelectedContactData(newConversation);
            
            // Create an initial message based on our patterns
            const useThankYouFormat = Math.random() > 0.5;
            let initialMessage;
            
            if (useThankYouFormat) {
                initialMessage = {
                    id: Date.now(),
                    body: `Thank you ${lead.firstName} for taking action today! Your call to Senator Treat's office about HB-3214 makes a real difference in protecting healthcare professionals' rights of conscience. If you'd like to stay informed about similar issues, reply YES to this message.`,
                    direction: "outbound",
                    createdAt: new Date().toISOString()
                };
            } else {
                initialMessage = {
                    id: Date.now(),
                    body: `Hello ${lead.firstName}, thank you for speaking with us today about HB-3214. This bill protecting healthcare professionals' rights of conscience is critical. Please consider calling Senator Treat's office directly at 405-521-5632. If you'd like to stay informed about similar issues, reply YES to this message.`,
                    direction: "outbound",
                    createdAt: new Date().toISOString()
                };
            }
            
            // Set the initial message
            setMessages([initialMessage]);
            
            // Update the conversation's last message
            newConversation.lastMessage = initialMessage.body.substring(0, 50) + "...";
            newConversation.lastMessageAt = initialMessage.createdAt;
        }
        
        closeComposeModal();
    };

    // Filter conversations based on search term
    const filteredConversations = conversations.filter(conv => 
        conv.contact.toLowerCase().includes(searchTerm.toLowerCase()) ||
        conv.phone.includes(searchTerm) ||
        conv.district.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Add this function inside the SMSInbox component
    const getContactInitials = (name) => {
        if (!name) return "?";
        const nameParts = name.split(" ");
        if (nameParts.length === 1) return nameParts[0].charAt(0);
        return nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0);
    };

    return (
        <div className="sms-inbox-container">
            <div className="conversations-panel">
                <div className="conversations-header">
                    <h3>Voter Conversations</h3>
                    <button className="compose-btn" onClick={openComposeModal}>
                        <i className="fas fa-pen"></i> New Message
                    </button>
                </div>
                
                <div className="search-container">
                    <input 
                        type="text" 
                        placeholder="Search contacts or districts..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                    />
                </div>
                
                {loadingConversations ? (
                    <div className="loading-conversations">
                        <div className="loading-spinner"></div>
                        <p>Loading conversations...</p>
                    </div>
                ) : (
                    <ul className="conversation-list">
                        {filteredConversations.map((conv) => (
                            <li
                                key={conv.id}
                                className={`conversation-item ${conv.contact === selectedContact ? "active" : ""} ${conv.unread ? "unread" : ""}`}
                                onClick={() => handleSelectConversation(conv.contact)}
                            >
                                <div className="conversation-avatar">
                                    {conv.avatar ? (
                                        <img src={conv.avatar} alt={conv.contact} />
                                    ) : (
                                        <div className="avatar-initials">{getContactInitials(conv.contact)}</div>
                                    )}
                                    {conv.unread && <span className="unread-badge"></span>}
                                </div>
                                <div className="conversation-details">
                                    <div className="contact-info">
                                        <div className="contact-name">{conv.contact}</div>
                                        <div className="contact-district">{conv.district}</div>
                                    </div>
                                    <div className="message-preview">{conv.lastMessage}</div>
                                    <div className="last-message-time">
                                        {new Date(conv.lastMessageAt).toLocaleString(undefined, { 
                                            month: 'short', 
                                            day: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </div>
                                </div>
                            </li>
                        ))}
                        {filteredConversations.length === 0 && (
                            <li className="no-results">No matching conversations found.</li>
                        )}
                    </ul>
                )}
            </div>
            
            <div className="messages-panel">
                {selectedContact ? (
                    <>
                        <div className="messages-header">
                            {selectedContactData && (
                                <>
                                    <div className="selected-contact-avatar">
                                        {selectedContactData?.avatar ? (
                                            <img src={selectedContactData.avatar} alt={selectedContact} />
                                        ) : (
                                            <div className="avatar-initials">{getContactInitials(selectedContact)}</div>
                                        )}
                                    </div>
                                    <div className="selected-contact-info">
                                        <h3>{selectedContact}</h3>
                                        <div className="contact-details">
                                            <span className="contact-phone">{selectedContactData.phone}</span>
                                            <span className="contact-district">{selectedContactData.district}</span>
                                        </div>
                                    </div>
                                    <div className="message-actions">
                                        <button className="action-btn call-btn" title="Call voter">
                                            <i className="fas fa-phone"></i>
                                        </button>
                                        <button className="action-btn info-btn" title="View voter info">
                                            <i className="fas fa-info-circle"></i>
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                        
                        <div className="messages-history">
                            {loadingMessages ? (
                                <div className="loading-messages">
                                    <div className="loading-spinner"></div>
                                    <p>Loading conversation...</p>
                                </div>
                            ) : messages.length > 0 ? (
                                messages.map((msg) => (
                                    <div
                                        key={msg.id}
                                        className={`message ${
                                            msg.direction === "outbound" ? "sent" : "received"
                                        }`}
                                    >
                                        <div className="message-body">{msg.body}</div>
                                        <div className="message-timestamp">
                                            {new Date(msg.createdAt).toLocaleTimeString(undefined, { 
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-messages">
                                    <p>No messages yet. Start the conversation!</p>
                                </div>
                            )}
                        </div>
                        
                        <div className="message-input-container">
                            <input
                                type="text"
                                placeholder="Type your message..."
                                value={newMessage}
                                onChange={(e) => setNewMessage(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") handleSendMessage();
                                }}
                            />
                            <button onClick={handleSendMessage} disabled={!newMessage.trim()}>
                                <i className="fas fa-paper-plane"></i> Send
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="no-conversation-selected">
                        <div className="no-selection-icon">
                            <i className="fas fa-comments"></i>
                        </div>
                        <h3>Select a conversation</h3>
                        <p>Choose a conversation from the list or start a new one</p>
                        <button className="start-new-btn" onClick={openComposeModal}>
                            <i className="fas fa-pen"></i> New Message
                        </button>
                    </div>
                )}
            </div>

            {/* Compose Modal */}
            {isComposeModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>New Voter Message</h3>
                            <button className="close-btn" onClick={closeComposeModal}>×</button>
                        </div>
                        
                        <div className="modal-search">
                            <input 
                                type="text" 
                                placeholder="Search voters by name or district..." 
                                className="modal-search-input" 
                            />
                        </div>
                        
                        <div className="modal-body">
                            {loadingComposeLeads ? (
                                <div className="loading-leads">
                                    <div className="loading-spinner"></div>
                                    <p>Loading voter contacts...</p>
                                </div>
                            ) : (
                                <ul className="compose-leads-list">
                                    {composeLeads.map((lead) => (
                                        <li
                                            key={lead.id}
                                            className="compose-lead-item"
                                            onClick={() => handleSelectLeadForCompose(lead)}
                                        >
                                            <div className="lead-details">
                                                <div className="lead-name">
                                                    {lead.firstName} {lead.lastName}
                                                </div>
                                                <div className="lead-subdetails">
                                                    <span className="lead-phone">{lead.phone}</span>
                                                    <span className="lead-district">{lead.district}</span>
                                                </div>
                                            </div>
                                            <div className="lead-support-level" data-level={lead.supportLevel.split(' ')[0].toLowerCase()}>
                                                {lead.supportLevel}
                                            </div>
                                        </li>
                                    ))}
                                    {composeLeads.length === 0 && (
                                        <li className="no-leads">No voter contacts available.</li>
                                    )}
                                </ul>
                            )}
                        </div>
                        
                        <div className="modal-footer">
                            <button className="cancel-btn" onClick={closeComposeModal}>Cancel</button>
                            <button className="all-contacts-btn">
                                <i className="fas fa-users"></i> View All Contacts
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SMSInbox;
